import {AccountPerformanceService} from "./AccountPerformanceService";
import {AccountPerformanceViewStore} from "./AccountPerformanceViewStore";

export class AccountPerformanceViewStoreFactory {

    public static id = "accountPerformanceViewStoreFactory";

    /** @ngInject */
    public constructor(private readonly accountPerformanceService: AccountPerformanceService) {
    }

    public create(portfolioId: number): AccountPerformanceViewStore {
        return AccountPerformanceViewStore.initialize(portfolioId, this.accountPerformanceService);
    }
}
